import {useEffect, useState} from "react";

interface IProjectTechStackItem {
    item: string
}

type Dictionary = { [index: string]: string }
export default function ProjectTechStackItem(props: IProjectTechStackItem) {

    const [renderImage, setRenderImage] = useState(true)

    const el = props.item;

    const getImageFilename = (el: string) => {
        el = el.toLowerCase();
        const assign: Dictionary = {
            'wordpress': 'wp.png',
            'scss': 'sass.png',
            'javascript': 'js.png',
            'git': 'git.svg',
            'webpack': 'webpack.svg',
            'bootstrap': 'bootstrap.svg',
            'jquery': 'jquery.svg',
            'html5': 'html.png',
            'stripe': 'stripe.svg',
            'nextjs': 'nextjs.svg',
            'nuxtjs': 'nuxtjs.svg',
            'tailwindcss': 'tailwind.svg',
            'tailwind': 'tailwind.svg',
            'twilio': 'twilio.svg',
            'inertia': 'inertiajs.png',
            'inertiajs': 'inertiajs.png',
            'aws': 'aws.svg',
            'mongodb': 'mongo.png',
            'yii framework': 'yii.png',
            'yii 2': 'yii.png',
            'yii': 'yii.png',
            'jira': 'jira.svg',
            'graphql': 'graphql.svg',
            'rest': 'rest.svg',
            'api': 'rest.svg',
            'joomla': 'joomla.svg',
            'typescript': 'typescript.svg',
            'ts': 'typescript.svg',
            'kafka': 'apachekafka.svg',
            'google cloud computing': 'googlecloud.png',
            'firebase': 'firebase.svg',
        };

        if (assign.hasOwnProperty(el)) {
            return assign[el];
        }

        return el + '.png';
    }

    const path = getImageFilename(el)

    const handleError = () => {
        setRenderImage(false)
    }

    return <span key={el} className={'flex gap-1 text-gray-400 items-center justify-items-center'}>
            {renderImage &&
                <img
                    src={`/stack/${path}`}
                    onError={handleError}
                    alt={el}
                    className={'h-4'}/>}
        {el}
                </span>
}